import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import type { BtnRadioProps } from '../types/interfaces'

import { faCircle } from '@fortawesome/pro-regular-svg-icons'
import { faScrubber } from '@fortawesome/pro-solid-svg-icons'

interface UseBtnRadioOptions {
  props: BtnRadioProps
  onClick: () => void
}

interface UseBtnRadioReturn {
  refIcon: ComputedRef<IconDefinition>
  handleClick: () => void
}

export const useBtnRadio = ({ props, onClick }: UseBtnRadioOptions): UseBtnRadioReturn => {
  const refIcon = computed<IconDefinition>(() => props.checked ? faScrubber : faCircle)

  /** A checked radio stays checked: clicking it again changes nothing. */
  const handleClick = (): void => {
    if (props.checked || props.disabled) return

    onClick()
  }

  return {
    refIcon,
    handleClick,
  }
}
